module.exports = __webpack_public_path__ + "media/images/games/35reveal/elephant-1797c1c72db6326bdc66733849ed0fb9.png";